<template>
  <div>
    <h1>Accounts Dashboard</h1>
  </div>
</template>

<script>
export default {
  name: 'AccountsDashboard'
}
</script>